<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section auth-title-section form-section flex">
              <h1 class="form-title">Set Your Password</h1>
              <img
                src="../../public/assets/images/padlock.png"
                class="title-section-img form-title-img ops-section-img padlock-img"
                alt="background image"
              >
            </article>
            <article class="auth-section">
              <p
                class="before"
              >Marshall, before submitting your application, please set your account password</p>
              <input
                type="password"
                class="orep-text-input auth-input"
                placeholder="Set your password"
              >
              <input
                type="password"
                class="orep-text-input auth-input"
                placeholder="Confirm Password"
              >
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'review'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <span class="pagination-dots"></span>
              <span class="pagination-dots"></span>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <router-link :to="{name:'login'}" class="next-btn mont spaced text-uppercase">
              submit
              <i class="fas fa-arrow-right pull-right"></i>
            </router-link>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "setPassword",
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    hamSpin() {
      this.isActive = !this.isActive;
    }
  },
  components: {}
};
</script>
